import matchPath from 'react-router-dom/matchPath';

export function useIsNodeActive(routes, pathname) {
    for ( let i = 0; i < routes.length; i++ ) {
        let route = routes[i];
        let match = matchPath(pathname, route);
        if ( match !== null && match.url === pathname ) return 'active';
    }

    return '';
}



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/sidebar/menu/menus-by-role/menu-nodes/MenuNodeActive.js